"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorEnum = void 0;
var ColorEnum;
(function (ColorEnum) {
    ColorEnum["brand"] = "brand";
    ColorEnum["red"] = "red";
    ColorEnum["green"] = "green";
})(ColorEnum = exports.ColorEnum || (exports.ColorEnum = {}));
